<template>
  <nav class="navbar navbar-expand-lg navbar-dark">
    <div class="container">
      <a class="navbar-brand" href="#"
         :style="{color: estilo.barraNavegacion.nombre.color, 'font-size': estilo.barraNavegacion.nombre.font_size+'px'}">
        Centro de Ayuda
      </a>
      <ul class="navbar-nav mr-auto"></ul>
      <div class="form-inline my-2 my-md-0">

        <div id="google_translate_element" :style="{color: estilo.barraNavegacion.idioma.color, 'font-size': estilo.barraNavegacion.idioma.font_size+'px'}">
          Idiomas
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
  export default {
    name: "barraNavegacionPublic",
    data() {
      return {
        value: '',
        estilo: {
          barraNavegacion: {
            nombre: {color: '', font_size: ''},
            idioma: {color: '', font_size: ''}
          }
        }
      }
    },
    beforeCreate() {
    },
    created() {
      EventBus.$on('nombreEmpresa', this.nombreEmpresa);
      EventBus.$on('barraNavegacion', this.estilos);
    },
    methods: {
      nombreEmpresa: function (data) {
        this.value = data;
      },
      estilos: function (data) {
        this.estilo.barraNavegacion = data.barraNavegacion;
        this.estilo.barraNavegacion.idioma.font_size = data.barraNavegacion.idioma['font-size'];
        this.estilo.barraNavegacion.nombre.font_size = data.barraNavegacion.nombre['font-size'];
      },
    }
  }
</script>

<style scoped>
  .navbar {
    box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.0), 0 0 0 0 rgba(0, 0, 0, .0), 0 0 0 0 rgba(0, 0, 0, .0);
    -webkit-box-shadow: 0 0 0 0 rgba(0, 0, 0, 0.0), 0 0 0 0 rgba(0, 0, 0, .0), 0 0 0 0 rgba(0, 0, 0, .0);
  }
</style>



// WEBPACK FOOTER //
// src/components/publico/share/barraNavegacion.vue